<template>
		<div class="content wrap-page">
		<Header></Header>
			<div class="info crfff">
        <div style="text-align: center">
          <span class="fs50 w-title ac">{{$t('Shop')}}</span>
        </div>
        <div class="tab-content mt50">
          <div class="nav-tab">
            <span class="tab-li" @click="clickTab(key)" :class="{'btn-purple':active==key}" v-for="(item,key,index) in redeemList"><span>{{item.type_name}}</span></span>
          </div>
          <div class="shop-list mt30">
            <div class="" v-for="(item,key,index) in redeemList" v-if="active==key">
              <div class="li por" v-for="(item1,index1) in item.list">
                <div class="li-t disflex">
                  <div class="lf" :class="'lf'+index1">
                    <div class="disflex">
                      <img style="height: 160px;" :src="item1.image" />
                      <div class="">
                        <div class="title">{{item1.nickname}}</div>
                        <div class="prz">{{item1.mobile}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="rf">
                    <div class="disflex">
                      <div class="pt-font">
                        <div>
                          <div class="disflex" v-if="active=='redeem'">
                            <img class="ml10" width="60" src="../../static/images/hd-ic3.png">
                            <div class="ml10 fs50">{{item1.need_points}}</div>
                          </div>
                          <div class="">{{item1.title}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="btn-green" @click="getUpgrade(1,item1)" v-if="active=='redeem'"><span>{{item1.type}}</span></div>
                <div class="btn-green" @click="getUpgrade(1,item1)" v-if="active=='purchase'"><span>{{item1.need_points}} Ks</span></div>
                <div class="cpon ac" style="margin-top: 5px"><span>{{item1.name}}</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="home-bottom disflex">
          <div class="bt-icon1" @click="getToNav('book')">
            <img src="../../static/images/mb-ic1.png">
            <span class="">{{$t('books')}}</span>
          </div>
          <div class="bt-icon1" @click="getToNav('bank')">
            <img src="../../static/images/mb-ic2.png">
            <span class="">{{$t('bank')}}</span>
          </div>
          <div class="bt-icon1 bt-icon2" @click="getToNav('')">
            <img src="../../static/images/mb-ic3.png">
            <span class="">{{$t('home')}}</span>
          </div>
          <div class="bt-icon1 active" @click="getToNav('shop')">
            <img style="margin-top: -30px;" src="../../static/images/mb-ic4-h.png">
            <span class="">{{$t('shop')}}</span>
          </div>
          <div class="bt-icon1" @click="getToNav('language')">
            <img src="../../static/images/mb-ic5.png">
            <span class="">{{$t('Settings')}}</span>
          </div>
        </div>
        <Dialog ref="bookDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
            <div class="" slot="mdBox">
              <div class="answer-modal invitation-dialog por">
              <div class="close ar" style="position: absolute;right:-20px;top:-20px" @click="cancelBookDialog"><img src="../../static/images/close.png"></div>
                	<div class="">
                    <div class="fs50 mt20 ac">{{upgradeInfo.name}}</div>
                    <div class="disflex" style="justify-content: center;" v-if="active=='redeem'">
                      <img class="ml10" width="60" src="../../static/images/hd-ic3.png">
                      <div class="ml10 fs50">{{upgradeInfo.need_points}}</div>
                    </div>
                    <div class="fs33 mt20 ac">{{upgradeInfo.title}}</div>
                    <div class="ac mt30">
                      <img :src="upgradeInfo.image">
                    </div>
                	</div>
                <div class="mt30 disflex">
                  <button class="btn btn-red" style="width: auto;min-width: 250px;" @click="cancelBookDialog"><span>{{$t('Cancel')}}</span></button>
                  <button class="btn btn-green" style="width: auto;min-width: 250px;" v-if="active=='redeem'" @click="getUpgrade(2)"><span>{{upgradeInfo.type}}</span></button>
                  <button class="btn btn-green" style="width: auto;min-width: 250px;" v-if="active=='purchase'" @click="getUpgrade(2)"><span>{{$t('Confirm')}}</span></button>
                </div>
              </div>
            </div>
        </Dialog>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:null,
       info:{},
       redeemInfo:{},
        redeemList:[],
        active:'redeem',
        upgradeInfo:{
          upgrade:{
            tip:''
          }
        }
      }
    },
	created(){
    this.getRedeem()
	},
  methods: {

    getToNav(url){
      this.$router.push({path:'/'+url});
    },
		back(){
			this.$router.go(-1);
		},
    clickTab(item){
      this.active = item
    },
    getUpgrade(type,item){
      console.log(type)
      let that = this
      if(type==1){
        this.upgradeInfo = item
        this.$refs.bookDialog.showMaskFun();
      }else{
         let data = {
            id:this.upgradeInfo.id
          }
          that.$parent.loadModal(true);
          that.$api.post('/api/shop/redeem',data,r =>{
            this.$utils.alertText(r.msg,80, 1000);
            that.getRedeem()
            that.$parent.loadModal(false);
          })
      }

    },
    cancelBookDialog(){
      this.$refs.bookDialog.closeMask();
    },
    getRedeem(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/shop/list',null,r =>{
        that.redeemList = r.data
        that.$parent.loadModal(false);
      })
    },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/shop.vue